import React, {Component} from 'react';
import DateRangeFilter from '../components/DateRangeFilter';
import SystemsReport from '../components/SystemsReport';
import ReportHeaderSystem from './ReportHeaderSystem';
import {ViewTitle} from 'admin-on-rest/lib/mui';
import {getTimeZoneOffsetDefault} from '../shared/dateTimeLists';
import {reportStyles} from '../shared/styles-reports';
import {Card, CardText} from 'material-ui/Card';
import CircularProgress from 'material-ui/CircularProgress';
import RaisedButton from 'material-ui/RaisedButton';
import Avatar from 'material-ui/Avatar';
import Icon from 'material-ui/svg-icons/editor/insert-chart';

/**
 * Systems Reports class for retrieving and displaying summary
 *
 */
export class SystemsReportContainer extends Component {
    constructor(props) {
        super(props);
        const offsetDefault = getTimeZoneOffsetDefault();
        this.state = {
            errorMessage: null,
            selectedEndDate: null,
            selectedStartDate: null,
            selectedOffset: offsetDefault,
            summaryComplete: false,
            system: '',
        };
    }

    componentWillMount() {
        const system = localStorage.getItem('system');
        this.setState({system: system});
    }

    /**
     * Convert Dates to visual display
     *
     * @param selectedStartDate
     * @param selectedEndDate
     * @return {string}
     */
    displaySelectedDates(selectedStartDate, selectedEndDate) {
        const options = {year: 'numeric', month: 'long', day: 'numeric'};
        let startDate = new Date(selectedStartDate + 'T00:00:00');
        let endDate = new Date(selectedEndDate + 'T00:00:00');
        let startDateStr = startDate.toLocaleDateString('en-US', options);
        let endDateStr = endDate.toLocaleDateString('en-US', options);

        return (
            'Date Range: ' + startDateStr + ' through ' + endDateStr
        )
    }

    /**
     * Handle event props from DateRangeFilter
     *
     * @param type
     * @param value
     */
    handleFilterSelect = (type, value) => {
        switch (type) {
            case 'start_date':
                // Set Start Date selection for reports summary component
                this.setState({errorMessage: null, selectedStartDate: value});
                break;
            case 'end_date':
                // Set End selection for reports summary component
                this.setState({errorMessage: null, selectedEndDate: value});
                break;
            case 'offset':
                // Set Time Zone Offset selection for reports summary component
                this.setState({errorMessage: null, selectedOffset: value});
                break;
            default:
                return
        }
    };

    /**
     * Handle event props for Systems Summary table completion
     *
     * @param isComplete
     */
    handleSummaryComplete = (isComplete) => {
        this.setState({
            errorMessage: null,
            summaryComplete: isComplete,
        });
    };

    handleReportError = (message) => {
        this.setState({
            errorMessage: message,
            summaryComplete: true,
        });
    };

    handlePrintClick = (event) => {
        window.print();
    };

    render() {
        const {
            errorMessage,
            selectedEndDate,
            selectedStartDate,
            selectedOffset,
            summaryComplete,
            system
        } = this.state;

        const ListTitle = <span className="list-title hide-print">
            <Avatar icon={<Icon/>} className="avatar-title"/>Systems Reports</span>;

        const ListDescription = () => {
            return (
                <span className="list-description hide-print">
                    <p>A Systems Report compares assigned devices and locations for a System versus devices and
                        locations actually used for sales.</p>
                    <p>Select a Date Range and Time Zone Offset to generate a Report:</p>
                </span>
            );
        };

        return (
            <div className="lists-container">
                <Card>
                    <ViewTitle title={ListTitle}/>
                    <CardText>
                        <ListDescription/>

                        {/* Report Filter (Start Date, End Date, Time Zone) */}
                        <DateRangeFilter
                            onSelectStartDate={this.handleFilterSelect}
                            onSelectEndDate={this.handleFilterSelect}
                            onSelectOffset={this.handleFilterSelect}
                        />

                        {/* Print Header */}
                        {selectedStartDate && selectedEndDate &&
                        <ReportHeaderSystem
                            reportType="Systems Report"
                        />
                        }

                        {/* Systems Report Content */}
                        {selectedStartDate && selectedEndDate && selectedOffset &&
                        <div>

                            {/* Report Header, Loader, and messaging */}
                            <div className="report-header">
                                <div className="btn-print-container report-header-button-container">
                                    <RaisedButton
                                        primary
                                        type="button"
                                        label="Print Report"
                                        style={reportStyles.button}
                                        onClick={(e) => this.handlePrintClick(e)}
                                    />
                                </div>
                                <h2 className="report-header-title">Systems Report</h2>
                                <p>
                                    {this.displaySelectedDates(selectedStartDate, selectedEndDate)}
                                </p>
                            </div>
                            {!summaryComplete &&
                            <div className="loader-container">
                                <h4>Generating Report...</h4>
                                <CircularProgress
                                    size={24}
                                    thickness={2}
                                    className="loader"
                                />
                            </div>
                            }

                            {/* Summary Report */}
                            <SystemsReport
                                startDate={selectedStartDate}
                                endDate={selectedEndDate}
                                offset={selectedOffset}
                                onSummaryComplete={this.handleSummaryComplete}
                                onError={this.handleReportError}
                                system={system}
                            />

                            {/* Error and Messaging */}
                            {errorMessage &&
                                <div className="error">
                                    <p>{errorMessage}</p>
                                </div>
                            }
                        </div>
                        }
                    </CardText>
                </Card>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/Fuse/Report/SystemsReportContainer.js